var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.options),function(option){return _c('span',{key:option,staticClass:"option",class:[{ active: _vm.border === option }, `option--${option}`],on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.update(option)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }